var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionRemoveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62543 6.83361C8.07525 6.83361 9.25056 5.52772 9.25056 3.91681C9.25056 2.3059 8.07525 1 6.62543 1C5.17561 1 4.00031 2.3059 4.00031 3.91681C4.00031 5.52772 5.17561 6.83361 6.62543 6.83361Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.5001V16.0001H12.2505V15.5001C12.2505 13.6332 12.2505 12.6997 11.9236 11.9866C11.6359 11.3594 11.1769 10.8494 10.6124 10.5298C9.97066 10.1665 9.13054 10.1665 7.45031 10.1665H5.80023C4.12 10.1665 3.27988 10.1665 2.63811 10.5298C2.07359 10.8494 1.61463 11.3594 1.327 11.9866C1 12.6997 1 13.6332 1 15.5001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5004 6.41626H16.0006",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRemoveUser);
export default __webpack_public_path__ + "static/media/action-remove-user.99e91c620ee2e2a06c6314bfee336963.svg";
export { ForwardRef as ReactComponent };